import { useContext, useLayoutEffect, useRef, useState } from "react";
import "./Menu.css";
import { CloseButtonBig, HeaderSmall, HeaderWithButton, LangSelection } from "./Common";
import { useLocation } from "react-router-dom";
import { OverlayContext } from "./App";
import { useNavigateSmart } from "./hooks";

export function Menu(props) {
    const overlay = useContext(OverlayContext);

    // For Menu
    const websiteAppRef = useRef();
    const [menuPosRight, setMenuPosRight] = useState(0);


    function handleTransitionEnd() {
        if(props.menuVisible) {
            if(window.innerWidth < 450) {
                document.body.style.overflow = "hidden";
            }
        }
        else {
            document.body.style.overflow = null;
        }
    }


    useLayoutEffect(() => {
        function calcMenuRight() {
            let rect = websiteAppRef.current.getBoundingClientRect();
            // let width = rect.right - rect.left;
            setMenuPosRight(rect.left); 
        }

        calcMenuRight();

        window.addEventListener("resize", calcMenuRight);
        return () => window.removeEventListener("resize", calcMenuRight);
    }, [props.menuVisible]);

     useLayoutEffect(() => {
        // Ensure that this is not set when the component unmounts
        return () => document.body.style.overflow = null;
    }, []);


    return (
        <div ref={websiteAppRef}>
            <div className={ "menu_box" + (props.menuVisible ? " menu_box_visible" : "")} style={{right: menuPosRight}}
                    onTransitionEnd={handleTransitionEnd}>
                <div id="overlay_menu" className={"overlay" + (overlay.overlay ? " overlay_visible": "")}></div>

                <HeaderWithButton small={true} management={props.management} closeBtn={true} onClick={() => props.onMenuClick()}/>

                <div className={"menu_content" + (props.menuVisible ? " menu_content_visible" : "")} >
                    <div id="menu_lang_selection_box">
                        <LangSelection />
                    </div>
                    
                    <div id="menu_options_box">
                        {props.options}
                    </div>
                </div>
            </div>
        </div>
    )
}

export function MenuOption(props) {
    const location = useLocation();
    const navigate = useNavigateSmart();

    if(props.onClick) {
        var handleClick = props.onClick;
    }
    else {
        var handleClick = (e) => {
            navigate(props.path);
            props.setMenuVisible(false);
        }
    }

    if(props.exact) {
        var selected = location.pathname === props.path;
    }
    else {
        var selected = location.pathname.startsWith(props.path);
    }

    return (
        <div className={"menu_option noselect" + (selected ? " menu_option_selected" : "")} onClick={handleClick}>
            <div className="menu_option_text">{props.text}</div>
            
            { props.addEle ?
                <div className="menu_option_add_ele">
                    {props.addEle}
                </div>
            :
                null
            }
            
        </div>
    );
}
